import script from "./MallMyReviewsPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./MallMyReviewsPage.vue?vue&type=script&setup=true&lang=ts"

import "./MallMyListPage.scss?vue&type=style&index=0&lang=scss&external"

const __exports__ = script;

export default __exports__